import React from "react";
import { useTranslation } from "react-i18next";

function clampScore(v) {
  const n = parseInt(v, 10);
  if (Number.isNaN(n)) return 0;
  return Math.max(0, Math.min(20, n));
}

const TipPreviewCard = ({
  sport, scenario,
  homeScore, awayScore, onHome, onAway,
  overtime, onOvertime,
  advancing, onAdvancing,
  homeColor, awayColor,
  aggregate,
  accent,
}) => {
  const { t } = useTranslation();
  const isSecondLeg = scenario === "SECOND_LEG";
  // Football overtime is derived from the score (a draw after 90 min / on aggregate),
  // exactly like the real match card — no manual checkbox. Only hockey toggles it
  // explicitly, because its golden-goal score is a win even though regulation was a draw.
  const showOvertimeToggle = sport === "HOCKEY";
  const showAdvancingUi = sport === "FOOTBALL" && scenario !== "STANDARD" && overtime;

  const homeName = t("scoring.team.home");
  const awayName = t("scoring.team.away");

  const headerStyle = accent
    ? { background: `linear-gradient(135deg, ${accent[0]}, ${accent[1]})` }
    : undefined;

  return (
    <div className="scoring-tip-card">
      <div className="scoring-tip-card__header" style={headerStyle}>
        <span className="scoring-tip-card__icon">✎</span>
        <span>{t("scoring.tip.title")}</span>
      </div>

      <div className="scoring-tip-card__body">
        <div className="scoring-tip-row">
          <div className="scoring-tip-row__team">
            <span className="scoring-tip-row__dot" style={{ background: homeColor }} />
            <div className="scoring-tip-row__role">{homeName}</div>
          </div>
          <input
            type="number"
            className="scoring-tip-row__input"
            value={homeScore}
            onChange={(e) => onHome(clampScore(e.target.value))}
            min="0"
            max="20"
          />
        </div>

        <div className="scoring-tip-row">
          <div className="scoring-tip-row__team">
            <span className="scoring-tip-row__dot" style={{ background: awayColor }} />
            <div className="scoring-tip-row__role">{awayName}</div>
          </div>
          <input
            type="number"
            className="scoring-tip-row__input"
            value={awayScore}
            onChange={(e) => onAway(clampScore(e.target.value))}
            min="0"
            max="20"
          />
        </div>

        {showOvertimeToggle && (
          <label
            className="scoring-tip-toggle"
            style={accent ? { "--tip-accent": accent[1] } : undefined}
          >
            <input
              type="checkbox"
              checked={overtime}
              onChange={(e) => onOvertime(e.target.checked)}
            />
            <span className="scoring-tip-toggle__slider" />
            <span className="scoring-tip-toggle__label">
              {sport === "FOOTBALL"
                ? t("scoring.overtime.football")
                : t("scoring.overtime.hockey")}
            </span>
          </label>
        )}

        {isSecondLeg && aggregate && (
          <div className={`scoring-aggregate ${aggregate.draw ? "is-draw" : ""}`}>
            <span className="scoring-aggregate__label">{t("scoring.aggregate.label")}</span>
            <span className="scoring-aggregate__score">{aggregate.home}:{aggregate.away}</span>
            {aggregate.draw && (
              <span className="scoring-aggregate__chip">{t("scoring.aggregate.draw")}</span>
            )}
          </div>
        )}

        {showAdvancingUi && (
          <div className="scoring-advancing">
            <div className="scoring-advancing__label">{t("scoring.advancing")}</div>
            <div className="scoring-advancing__options">
              <label>
                <input
                  type="radio"
                  checked={advancing === "HOME"}
                  onChange={() => onAdvancing("HOME")}
                />
                <span>{homeName}</span>
              </label>
              <label>
                <input
                  type="radio"
                  checked={advancing === "AWAY"}
                  onChange={() => onAdvancing("AWAY")}
                />
                <span>{awayName}</span>
              </label>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TipPreviewCard;
